var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiPageTitle',{attrs:{"title":_vm.date,"back-link":{ to: _vm.backLink }}})}
var staticRenderFns = []

export { render, staticRenderFns }